import React, { useState } from "react";
import "./estilos/Contactanos.css";
import Separar from "../componentes/Separador NavBar/Separador";
import { useTranslation } from "react-i18next";

function Contactanos() {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    nombre: "",
    correo: "",
    telefono: "",
    asunto: "",
    mensaje: ""
  });

  const [errores, setErrores] = useState({});
  const [estado, setEstado] = useState("");
  const [enviando, setEnviando] = useState(false);

  const validarCampo = (nombre, valor) => {
    switch (nombre) {
      case 'nombre':
        if (!valor.trim()) return t('contactanos.errores.nombre_requerido');
        if (valor.length < 2) return t('contactanos.errores.nombre_minimo');
        if (!/^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]+$/.test(valor)) return t('contactanos.errores.nombre_invalido');
        return "";
      
      case 'correo':
        if (!valor.trim()) return t('contactanos.errores.correo_requerido');
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(valor)) return t('contactanos.errores.correo_invalido');
        return "";
      
      case 'telefono':
        if (valor && !/^[\d\s\-\+\(\)]+$/.test(valor)) return t('contactanos.errores.telefono_invalido');
        return "";
      
      case 'asunto':
        if (!valor.trim()) return t('contactanos.errores.asunto_requerido');
        if (valor.length < 3) return t('contactanos.errores.asunto_minimo');
        return "";
      
      case 'mensaje':
        if (!valor.trim()) return t('contactanos.errores.mensaje_requerido');
        if (valor.length < 10) return t('contactanos.errores.mensaje_minimo');
        return "";
      
      default:
        return "";
    }
  };  const handleChange = (e) => {
    const { name, value } = e.target;
    
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));

    // Validar campo en tiempo real
    const error = validarCampo(name, value);
    setErrores(prev => ({
      ...prev,
      [name]: error
    }));
  };

  const validarFormulario = () => {
    const nuevosErrores = {};
    
    Object.keys(formData).forEach(campo => {
      if (campo !== 'telefono') { // teléfono es opcional
        const error = validarCampo(campo, formData[campo]);
        if (error) nuevosErrores[campo] = error;
      }
    });

    setErrores(nuevosErrores);
    return Object.keys(nuevosErrores).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validarFormulario()) {
      setEstado(t('contactanos.errores.corregir'));
      return;
    }

    setEnviando(true);
    setEstado(t('contactanos.mensajes.enviando'));

    try {
      const apiUrl = process.env.REACT_APP_CMS_API_URL || 'http://localhost:5001/api';
      const response = await fetch(`${apiUrl}/contact`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setEstado(t('contactanos.mensajes.exito'));
        setFormData({ nombre: "", correo: "", telefono: "", asunto: "", mensaje: "" });
        setErrores({});
        setTimeout(() => setEstado(""), 5000);
      } else {
        const data = await response.json().catch(() => ({}));
        setEstado(data.error || t('contactanos.mensajes.error'));
      }
    } catch (error) {
      setEstado(t('contactanos.mensajes.error'));
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div className="contactanos-container">
      <Separar />
      
      <div className="contactanos-header">
        <h1 className="contactanos-titulo">{t('contactanos.titulo')}</h1>
        <p className="contactanos-subtitulo">
          {t('contactanos.subtitulo')}
        </p>
      </div>

      <form className="contactanos-form" onSubmit={handleSubmit}>
        <div className="campo-grupo">
          <label className="contactanos-label">
            <span className="label-texto">
              {t('contactanos.campos.nombre')} <span className="requerido">*</span>
            </span>
          </label>
          <input
            className={`contactanos-input ${errores.nombre ? 'error' : ''}`}
            type="text"
            name="nombre"
            value={formData.nombre}
            onChange={handleChange}
            placeholder={t('contactanos.placeholders.nombre')}
          />
          {errores.nombre && <span className="mensaje-error">{errores.nombre}</span>}
        </div>

        <div className="campo-grupo">
          <label className="contactanos-label">
            <span className="label-texto">
              {t('contactanos.campos.correo')} <span className="requerido">*</span>
            </span>
          </label>
          <input
            className={`contactanos-input ${errores.correo ? 'error' : ''}`}
            type="email"
            name="correo"
            value={formData.correo}
            onChange={handleChange}
            placeholder={t('contactanos.placeholders.correo')}
          />
          {errores.correo && <span className="mensaje-error">{errores.correo}</span>}
        </div>

        <div className="campo-grupo">
          <label className="contactanos-label">
            {t('contactanos.campos.telefono')}
          </label>
          <input
            className={`contactanos-input ${errores.telefono ? 'error' : ''}`}
            type="tel"
            name="telefono"
            value={formData.telefono}
            onChange={handleChange}
            placeholder={t('contactanos.placeholders.telefono')}
          />
          {errores.telefono && <span className="mensaje-error">{errores.telefono}</span>}
        </div>

        <div className="campo-grupo">
          <label className="contactanos-label">
            <span className="label-texto">
              {t('contactanos.campos.asunto')} <span className="requerido">*</span>
            </span>
          </label>
          <input
            className={`contactanos-input ${errores.asunto ? 'error' : ''}`}
            type="text"
            name="asunto"
            value={formData.asunto}
            onChange={handleChange}
            placeholder={t('contactanos.placeholders.asunto')}
          />
          {errores.asunto && <span className="mensaje-error">{errores.asunto}</span>}
        </div>

        <div className="campo-grupo">
          <label className="contactanos-label">
            <span className="label-texto">
              {t('contactanos.campos.mensaje')} <span className="requerido">*</span>
            </span>
            <span className="contador-chars">
              {formData.mensaje.length}/500
            </span>
          </label>
          <textarea
            className={`contactanos-textarea ${errores.mensaje ? 'error' : ''}`}
            name="mensaje"
            rows="5"
            value={formData.mensaje}
            onChange={handleChange}
            placeholder={t('contactanos.placeholders.mensaje')}
            maxLength="500"
          ></textarea>
          {errores.mensaje && <span className="mensaje-error">{errores.mensaje}</span>}
        </div>

        <button 
          className={`contactanos-button ${enviando ? 'enviando' : ''}`} 
          type="submit"
          disabled={enviando}
        >
          {enviando ? (
            <>
              <span className="loader"></span>
              {t('contactanos.boton.enviando')}
            </>
          ) : (
            t('contactanos.boton.enviar')
          )}
        </button>
      </form>

      {estado && (
        <div className={`${estado.includes('Error') || estado.includes('corrige') ? 'mensaje-error-general' : 'mensaje-exito'}`}>
          {estado}
        </div>
      )}
    </div>
  );
}

export default Contactanos;
